import React  from 'react';
import CurrencyComponentProto from './currency-proto.jsx';


export default function renderCurrencyInFormNew(id, props) {
    return <CurrencyComponentProto renderMode="form-new" id={id} {...props} />;
}